import * as React from "react";
import { useState, useEffect } from "react";
import { Page } from "../../components/Page";
import {
  getBlockData,
  getCurrentUser,
  insertBlockData,
  updateBlockData,
  deleteBlockData,
} from "../../api-config/config";
import SimpleTable from "../../components/table/SimpleTable";
import LoaderWrapper from "../../components/LoaderWrapper/LoaderWrapper";

export default function NewBlockList() {
  const [blockList, setblockList] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const loggedUser = getCurrentUser();

  const getblockList = (hotel_code: number) => {
    setLoading(true);
    return getBlockData(hotel_code).then(
      (res: any) => {
        if (res?.status_message === "success") {
          setblockList(res.data);
        }
        setLoading(false);
      },
      (error: any) => {
        console.log("error", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getblockList(loggedUser?.hotel_code);
  }, []);

  function onBlockAdded() {
    getblockList(loggedUser?.hotel_code);
  }

  return (
    <Page title="Home">
      {loading && <LoaderWrapper />}
      <BlockListGrid
        row={blockList}
        loggedUser={loggedUser}
        onBlockAdded={onBlockAdded}
        setLoading={setLoading}
      />
    </Page>
  );
}

function BlockListGrid(data: any) {
  const { row, loggedUser, onBlockAdded, setLoading } = data;

  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const [blockName, setBlockName] = useState("");
  const [editingBlock, setEditingBlock] = useState<any>(null);

  const [snackbar, setSnackbar] = useState({
    visible: false,
    message: "",
    type: "error",
  });

  const showSnackbar = (message: string, type: "success" | "error" = "error") => {
    setSnackbar({ visible: true, message, type });
    setTimeout(() => {
      setSnackbar((prev) => ({ ...prev, visible: false }));
    }, 3000);
  };


  const handleSubmit = async () => {
    if (!blockName.trim()) {
      showSnackbar("Block Name is required!", "error");
      return;
    }

    try {
      setLoading(true);
      if (editingBlock) {
        const res = await updateBlockData({
          block_id: editingBlock.id,
          hotel_code: loggedUser?.hotel_code,
          block_name: blockName,
        });

        if (res?.status_message === "failed") {
          setLoading(false);
          showSnackbar(res.message || "Update failed", "error");
          return;
        }

        showSnackbar("Block Updated Successfully!", "success");
      } else {
        const res = await insertBlockData(
          loggedUser?.hotel_code,
          blockName
        );

        if (res?.status_message === "failed") {
          setLoading(false);
          showSnackbar(res.message || "Insert failed", "error");
          return;
        }

        showSnackbar("Block Added Successfully!", "success");
      }

      onBlockAdded();
      resetForm();
    } catch {
      setLoading(false);
      showSnackbar("Something went wrong", "error");
    }
  };


  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await deleteBlockData(editingBlock.id);

      if (res?.status_message === "failed") {
        setLoading(false);
        showSnackbar(res.message || "Delete failed", "error");
        return;
      }

      showSnackbar("Block Deleted Successfully!", "success");
      onBlockAdded();
      setDeleteOpen(false);
      setEditingBlock(null);
    } catch {
      setLoading(false);
      showSnackbar("Something went wrong", "error");
    }
  };

  const resetForm = () => {
    setOpen(false);
    setDeleteOpen(false);
    setBlockName("");
    setEditingBlock(null);
  };

  const rows: any[] = [];
  if (row) {
    row.forEach((item: any, index: number) => {
      rows.push({
        serial: index + 1,
        block: item.block_name,
        floor: item.floors.length || "0",
        status: item.is_active ? "Active" : "Inactive",
        raw: item,
      });
    });
  }

  const columns = [
    { header: "#", accessor: "serial", width: "5%" },
    { header: "Block Name", accessor: "block", width: "30%" },
    { header: "Floors", accessor: "floor", width: "20%" },
    { header: "Status", accessor: "status", width: "15%" },
    {
      header: "Actions",
      accessor: "actions",
      width: "15%",
      render: (_: any, row: any) => (
        <div style={{ display: "flex", gap: 14, justifyContent: "center" }}>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditingBlock(row.raw);
              setBlockName(row.raw.block_name);
              setOpen(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
            </svg>
          </span>

          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditingBlock(row.raw);
              setDeleteOpen(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 30"
              fill="red"
            >
              <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z" />
            </svg>
          </span>
        </div>
      ),
    },
  ];

  return (
    <div style={{ width: "100%", padding: "0px 20px" }}>
      <div className="roomtype-header">
        <h2 className="roomtype-title">Block List</h2>
        <div className="roomtype-btns">
          <button className="my-custom-btn" onClick={() => setOpen(true)}>
            Add Block
          </button>
        </div>
      </div>

      <SimpleTable columns={columns} data={rows} />

      {open && (
        <div className="modal-overlay" onClick={resetForm}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                {editingBlock ? "Edit Block" : "Add Block"}
              </h3>
            </div>

            <div className="modal-content" style={{ padding: "16px" }}>
              <input
                value={blockName}
                onChange={(e) => setBlockName(e.target.value)}
                placeholder="Enter Block Name"
                className="modal-input"
              />
            </div>

            <div className="modal-footer">
              <button className="my-custom-btn" onClick={handleSubmit}>
                Save
              </button>
              <button className="my-custom-btn" onClick={resetForm}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteOpen && (
        <div className="delete-modal-overlay" onClick={resetForm}>
          <div className="delete-modal-box" onClick={(e) => e.stopPropagation()}>
            <h3 className="delete-modal-title">Delete Block?</h3>
            <p className="delete-modal-desc">
              Block <span>{editingBlock?.block_name}</span> will be permanently removed.
            </p>

            <div className="delete-modal-actions">
              <button className="delete-btn-cancel" onClick={resetForm}>
                No
              </button>
              <button className="delete-btn-confirm" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        id="snackbar"
        className={`${snackbar.visible ? "show" : ""} ${snackbar.type}`}
      >
        {snackbar.message}
      </div>
    </div>
  );
}